import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCommentsIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M1.616 14q-.69 0-1.153-.462-.462-.462-.463-1.153V1.615Q0 .925.463.462A1.56 1.56 0 0 1 1.615 0h14.77q.69 0 1.152.462T18 1.615v13.518q0 .54-.497.745-.496.206-.876-.174L14.923 14zm13.734-1L17 14.644V1.616a.6.6 0 0 0-.192-.424.58.58 0 0 0-.423-.192H1.615a.6.6 0 0 0-.423.192.58.58 0 0 0-.192.423v10.77a.6.6 0 0 0 .192.423.58.58 0 0 0 .423.192z"
    />
  </svg>
)
export default SvgCommentsIcon
